import { Base, PageObject } from '@testsigmainc/models';
import { alias, deserialize, serializable } from 'serializr';

export class TestPlanTag extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable(alias('count'))
  public usedCount: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestPlanTag, input));
  }
}
